(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.contact-form__multiselect').forEach(function (details) {
      var label = details.querySelector('[data-multiselect-label]');
      var checkboxes = details.querySelectorAll('input[type="checkbox"]');
      var defaultText = label ? label.textContent : '';

      function updateLabel() {
        var selected = Array.prototype.filter
          .call(checkboxes, function (cb) {
            return cb.checked;
          })
          .map(function (cb) {
            return cb.value;
          });

        if (!label) return;
        label.textContent = selected.length ? selected.join(', ') : defaultText;
        label.style.color = selected.length ? '#000' : '#999';
      }

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', updateLabel);
      });

      document.addEventListener('click', function (event) {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
